import { api } from '../api';
import { DeviceInactivity } from '../../entities/Alert';

/**
 * ⚠️ **Lança o erro em vez de devolver zeros.** Painel zerado é resposta clínica
 * ("ninguém inativo"), e uma falha de rede não pode se passar por ela — quem chama
 * decide como mostrar a falha.
 */
export const getAlertsInactivity = async (): Promise<DeviceInactivity> => {
  const { data } = await api.get('/alerts/inactivity');

  return data;
};
